
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";

export default function ProcessingRequestRow({ id, project, file, processing, date }) {

    const { t } = useTranslation();

    const getFormattedDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString();
    }

    return(
        <>
        <TableRow
        hover
        key={id}
        >
        <TableCell>
            <Typography
                            color="text.primary"                           
                            variant="body1"
                        >  
            <b>{project}</b>
            </Typography>
        </TableCell>
        <TableCell>
            <Typography
                            color="text.secondary"                           
                            variant="body2"
                        >   
            {file}
            </Typography>
        </TableCell>
        <TableCell align="right">
            <Typography
                            color="text.secondary"                           
                            variant="body2"
                        >   
            {t(processing)}
            </Typography>
        </TableCell>
        <TableCell align="right">
            <Typography
                            color="text.secondary"                           
                            variant="body2"
                        >   
            {getFormattedDate(date)}
            </Typography>
        </TableCell>
        </TableRow>
        </>
    )
};